import React, { FC, useMemo } from 'react';

import { EventSchemeResource } from '../../../../../../../../../interfaces/reservation_flow';

export interface PaymentMethodsListProps {
  resource: EventSchemeResource;
}

export const PaymentMethodsList: FC<PaymentMethodsListProps> = ({
  resource,
}) => {
  const paymentMethodsString = useMemo(() => {
    return resource.enabled_payment_methods
      .map((paymentMethod) => {
        switch (paymentMethod) {
          case 'onsite':
            return '現地決済';
          case 'bank_transfer':
            return '銀行振込';
          case 'credit_card':
            return 'クレジットカード決済';
          case 'subscription':
            return '月謝';
          case 'ticket_book':
            return '回数券';
        }
      })
      .join('・');
  }, [resource]);

  return (
    <div className="m-0 box-border border-x-0 border-y border-solid border-gray-50 bg-white">
      <div className="box-border border-b border-l-0 border-r-0 border-t-0 border-solid border-gray-50  p-1.5 last-of-type:border-b-0">
        {(() => {
          if (resource.lowest_price === null) {
            return null;
          }

          return (
            <div className="rs-font mb-[2px] text-16 font-bold text-gray-1000 pc:text-15">
              {(() => {
                if (!resource.is_price_unique) {
                  return `¥${resource.lowest_price.toLocaleString()}~`;
                }

                return `¥${resource.lowest_price.toLocaleString()}`;
              })()}
            </div>
          );
        })()}
        <div className="rs-font text-16 font-normal text-gray-1000 pc:text-15">
          {paymentMethodsString}
        </div>
      </div>
    </div>
  );
};
